import { memo } from 'react';
import { Outlet } from 'react-router-dom';
import { Layout as BaseLayout, Main } from '@/shared/components/layout/layout';
import Header from '@/shared/components/layout/Header';

const RootLayout = () => {
	return (
		<BaseLayout>
			<Outlet />
		</BaseLayout>
	);
};

const AppLayout = () => {
	return (
		<>
			<Header />
			<Main>
				<Outlet />
			</Main>
		</>
	);
};

const FullScreenRouteLayout = () => {
	return <Outlet />;
};

export { RootLayout };

// 기존 라우트 import 호환용 alias
export const HeaderLayout = memo(AppLayout);
export const FullLayout = memo(FullScreenRouteLayout);
export const AppRouteLayout = memo(AppLayout);
export const FullScreenLayout = memo(FullScreenRouteLayout);
